import { json, data, config, componentType } from './export.state';
import { ExportConfig } from '@/modules/export/models/ExportConfig';

export function getRawJson(): Params {
  return json.value;
}

export function getData(): Params {
  return data.value;
}

export function getConfig(): ExportConfig | undefined {
  return config.value;
}

export function getComponentType(): string | undefined {
  return componentType.value;
}
